import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRegisterDataIntegrationStepControls } from 'src/features/Signup/hooks/useRegisterDataIntegrationStepControls';
import { ConnectChannelsStep } from 'src/features/Signup/components/templates/DataIntegrationFlow/steps/ConnectChannelsStep';
import {
  getStepIndex,
  getNextStepPath,
  getPrevStepPath,
} from 'src/features/Signup/utils/dataIntegrationSteps';

const nextPath = getNextStepPath('connect-channels');
const prevPath = getPrevStepPath('connect-channels');

export const ConnectChannelsStepRoute: React.FC = () => {
  const navigate = useNavigate();

  useRegisterDataIntegrationStepControls({
    title: 'Connect channels',
    subtitle:
      'Connect your communication channels to manage everything in one place.',
    currentStep: getStepIndex('connect-channels'),
    onNext: nextPath ? () => navigate(nextPath) : undefined,
    onBack: prevPath ? () => navigate(prevPath) : undefined,
    isBackDisabled: true,
    isNextDisabled: false,
  });

  return <ConnectChannelsStep />;
};
